import config from "../../../helper/config";
import APIHandler from "../../../handlers/APIHandler";

export const FieldListService = {
  getAllFieldList,
  getAllCrmUsers
};

async function getAllFieldList() {
  const configOptions = {
    method: "GET",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
  };
  const response = await fetch(
    `${config.oat_api_url}/manage/crm/field-list/getAll`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}

async function getAllCrmUsers(mid, form_list_id, lg_user_id, lg_user_table_id,limit,offset,sort_column,sort_direction) {
  const configOptions = {
    method: "GET",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
  };
  const response = await fetch(
    `${config.oat_api_url}/manage/crm/field-list/getAllCrmUsers/${mid}/${form_list_id}/${limit}/${offset}/${sort_column}/${sort_direction}?lg_user_id=${lg_user_id}&lg_user_table_id=${lg_user_table_id}`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}
